module.exports = __webpack_public_path__ + "static/media/0315_Medium.ca9e5cab.jpg";